export default "/assets/images/awards-img-02-lg.23b8b12076a87d4a.svg";